var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.2153V14.9861L3.87182 14.796C3.15186 13.7284 2.75 12.5134 2.75 11.2286C2.75 7.22843 6.74795 3.75 12 3.75C17.2521 3.75 21.25 7.22843 21.25 11.2286C21.25 15.2287 17.2521 18.7071 12 18.7071C10.8474 18.7071 9.74631 18.5364 8.73197 18.2257L8.48239 18.1493L8.23929 18.2443L4 19.9015V15.2153Z",
    stroke: "#95959D",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.d2485c31312a0002384d6bdaa2d5681b.svg";
export { ForwardRef as ReactComponent };